var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M2.278 18.729a.966.966 0 0 0 1.343 0l8.275-8.074a.91.91 0 0 0 0-1.31L3.62 1.271A.96.96 0 0 0 2.95 1a.958.958 0 0 0-.672.271.91.91 0 0 0 0 1.31L9.881 10l-7.603 7.418a.91.91 0 0 0 0 1.31z"
  })));
};
export default SvgArrowRight;